/**
 * Translation helper for Substrate Calculator
 * Uses WordPress localized translations passed via wp_localize_script
 */

/**
 * Get a translation string by key
 *
 * @param {string} key - Translation key
 * @param {string|number} [param] - Optional parameter for sprintf
 * @returns {string} Translated string
 */
export function t(key, param = null) {
    const translations = window.substrateCalculatorTranslations || {};

    if (!translations[key]) {
        console.warn(`Translation key "${key}" not found`);
        return key;
    }

    if (param !== null) {
        // Simple sprintf-like replacement for %s or %d
        return translations[key].replace(/%s|%d/g, param);
    }

    return translations[key];
}

/**
 * Check if translations are loaded
 *
 * @returns {boolean}
 */
export function hasTranslations() {
    return typeof window.substrateCalculatorTranslations !== 'undefined';
}

export default t;
